
export enum MatchedPartySourceCd {
	NOT_MATCHED = 'NotMatched',
	NOT_MATCHED_INVALID_ADDRESS_OVERRIDE = 'NotMatchedInvalidAddressOverride',
	SYSTEM_MATCHED = 'SystemMatched',
	USER_SELECTED = 'UserSelected',
	USER_SELECTED_SEARCH = 'UserSelectedSearch'}

